export function applyPageStats(page, stats) {
  if (!page || !page.data) {
    return page;
  }

  stats = stats || {};

  const data = {
    ...page.data,
    blocks: page.data.blocks.map(block => {
      if (!block.slugs) {
        return block;
      }

      const value = block.value && Object.keys(block.slugs).reduce((val, slug) => {
        return val.replace(`{{${slug}}}`, stats[slug] || block.slugs[slug]);
      }, block.value);

      const text = block.text && Object.keys(block.slugs).reduce((val, slug) => {
        return val.replace(`{{${slug}}}`, stats[slug] || block.slugs[slug]);
      }, block.text);

      return {
        ...block,
        value,
        text
      };
    }),
    files: {
      ...page.data.files,
      items: page.data.files.items.map((file, i) => {
        const newFile = { ...file };
        if (i === 0) {
          newFile.link = stats.investorPdf;
        } else if (i === 1) {
          newFile.link = stats.emitentPdf;
        }

        return newFile;
      })
    }
  };

  return {
    ...page,
    data
  };
}



// WEBPACK FOOTER //
// ./src/utils/pageStats.js